<template>
  <BreadCrumb PageTitle="Google sheets" />
  <SheetsApp />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import SheetsApp from "@/components/Generals/Stores/SheetsApp.vue";

export default defineComponent({
  name: "SheetsPage",
  components: {
    BreadCrumb,
    SheetsApp,
  },
});
</script>